// extracted by mini-css-extract-plugin
module.exports = {"img":"Img_img__1JKI7","img_background":"Img_img_background__mCvwb"};